export default "__VITE_ASSET__D$op74BA__"